<template>
    <div class="chat-detail-modal">
        <TitleBaseBox :title="title" :noButton="true" @close="close">
            <div class="chat-content">
                <div class="ask-total-num">
                    {{ $t("zhiji.robotLog.askNums") }}<span>{{ chatTotal }}</span>
                    <span class="trans-box">{{ $t("zhiji.robotLog.chatTranslate") }} <el-switch v-model="isTranslate"> </el-switch></span>
                </div>
                <div class="chat-log-detail scroll-tracker" ref="chatContent">
                    <ChatDetailText :answer="data.answerDetail" v-for="(item, idx) in chatData" :key="idx" :data="item" :isTranslate="isTranslate" />
                </div>
                <div class="loading-text">{{ computedText }}</div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import { debounce } from "@/views/zhiji/js/common/util.js";

import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import ChatDetailText from "./ChatDetailText";

export default {
    name: "ChatDetailModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        ChatDetailText
    },
    data() {
        return {
            askTotal: 100,
            chatData: [],
            curPage: 1,
            curPageLen: 10,
            chatTotal: "",
            chatDataLength: "",
            computedText: "",
            isTranslate: false
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.robotLog.sessionContent");
        },
        loadingText() {
            return this.$t("zhiji.common.dataReading");
        },
        noDataText() {
            return this.$t("zhiji.common.noData");
        }
    },
    mounted() {
        let target = this.$refs.chatContent;
        target.addEventListener(
            "scroll",
            debounce(() => {
                // 滚动节流
                this.handleScroll();
            }, 300)
        );
        this.computedText = this.loadingText;
        this.getDayChatData();
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        getDayChatData() {
            let reqData = {
                startDate: this.data.startDate,
                endDate: this.data.endDate,
                curPage: this.curPage,
                size: this.curPageLen,
                channel: "",
                questionType: "",
                answerType: "",
                searchType: "user",
                keyWord: this.data.userId,
                userId: this.data.userId,
                order: "asc" // 升序聊天内容
            };
            let timeDiffer = new Date(reqData.endDate) - new Date(reqData.startDate);

            timeDiffer > 0 &&
                this.zhiji.requestByServiceName("queryAskAnswerLog", reqData).then(result => {
                    this.computedText = "";
                    this.curPage = this.curPage + 1;
                    this.chatDataLength = result.tableData.length;
                    this.chatData = this.chatData.concat(result.tableData);
                    this.chatTotal = result.count;
                    if (this.chatDataLength == 0) {
                        this.computedText = this.noDataText;
                    }
                });
        },
        handleScroll() {
            if (this.chatDataLength == 10) {
                this.loadingNextPage(this.showLoadingText());
            } else {
                this.computedText = this.noDataText;
                if (!this.showLoadingText()) {
                    this.computedText = "";
                }
            }
        },
        showLoadingText() {
            let clientHeight = this.$refs.chatContent.clientHeight;
            let scrollTop = this.$refs.chatContent.scrollTop;
            let scrollHeight = this.$refs.chatContent.scrollHeight;
            let isScrollBottom = Math.floor(clientHeight + scrollTop) == scrollHeight;

            return isScrollBottom;
        },
        loadingNextPage(isScrollBottom) {
            if (isScrollBottom) {
                this.computedText = this.loadingText;
                this.getDayChatData();
            } else {
                this.computedText = "";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.chat-detail-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .chat-content {
        padding: 4px;
        width: 680px;
        position: relative;

        .ask-total-num {
            margin: -14px 0 8px;
        }

        .chat-log-detail {
            position: relative;
            padding: 24px 14px 24px;
            border: 1px solid #d8e4f0;
            background: #fafbfd;
            box-sizing: border-box;
            border-radius: 6px;
            height: 414px;
            overflow-y: auto;
        }
        .loading-text {
            position: absolute;
            bottom: 5px;
            left: -24px;
            padding: 8px;
            text-align: center;
            width: 100%;
            box-sizing: border-box;
        }
    }

    .trans-box {
        width: 200px;
        margin-left: 16px;
    }
}
</style>
